module.exports = __webpack_public_path__ + "img/w3_circle_trash_check_white.0d679587.png";